import React, { Component } from 'react';
import moment from 'moment';

import { activateUserDetailed } from '../actions/app-props';

import { userRoles } from '../constants'
import { getCurrentUserId } from '../services/store-service';
import { startConversation } from '../services/chat-service';
import { canUser } from '../services/permissions-service';

import CanUser from './can-user'
import Avatar from './avatar';
import Popout from './popout';
import Tooltip from './tooltip';

import iconClock from '../images/alpha-clock.png';

export default class MessageUser extends Component {
    state = {
        popoutVisible: false
    }

    handleClick = () => {
        this.popoutCtrl && this.popoutCtrl.show()
    }

    handlePopoutShow = () => {
        this.setState({
            popoutVisible: true
        });
    }

    handlePopoutHide = () => {
        this.setState({
            popoutVisible: false
        });
    }

    handleUserProfileClick = () => {
        activateUserDetailed(this.props.id);

        this.popoutCtrl.hide();
    }

    handleStartConversationClick = () => {
        startConversation(this.props.id)
    }

    getUserRoleById(roleId) {
        return userRoles().filter(role => role.id === roleId)[0] || {title: 'User Role'};
    }

    get avatarElement() {
        return (
            <Avatar
                className={this.props.bot ? 'bot' : ''}
                image={this.props.avatar}
                color={this.props.color}
                text={this.props.initials}
                showStatus={!this.props.bot}
                online={this.props.online || this.props.id === getCurrentUserId()}
            />
        )
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            showPopout: () => {
                this.popoutCtrl && this.popoutCtrl.show();
            }
        });
    }

    componentWillUnmount() {
        this.props.provideController && this.props.provideController(null);
    }

    render() {
        if (this.props.noTooltip) {
            return (
                <div className="message-user">
                    { this.avatarElement }
                </div>
            );
        }

        return (
            <div className="message-user" onClick={this.handleClick}>
                {
                    this.props.bot ? (
                        <Tooltip
                            type="popout"
                            className="medium orbit-help-tooltip"
                            placement="right-start"
                            tooltip={
                                <div className="popout-inner">
                                    <div className="popout-body">
                                        <div className="side">
                                            <img src={iconClock} alt="clock" />
                                        </div>

                                        <div className="body">
                                            <h4>NIFTY ORBIT (EARLY ALPHA)</h4>

                                            <p>You’re witnessing the early stages of Nifty Orbit — a soon-to-be advanced AI system that will do a lot of your boring work. More on it soon!</p>
                                        </div>
                                    </div>
                                </div>
                            }
                        >
                            <div>
                                { this.avatarElement }
                            </div>
                        </Tooltip>
                    ) : (
                        <React.Fragment>
                            { this.avatarElement }

                            <Popout provideController={ctrl => this.popoutCtrl = ctrl} onShow={this.handlePopoutShow} onHide={this.handlePopoutHide} className="user-card-holder" xAlign="right" yAlign="top">
                                <div className="user-card">
                                    <div className="card-body">
                                        <div className="card-body-side">
                                            <Avatar
                                                image={this.props.avatar}
                                                color={this.props.color}
                                                text={this.props.initials}
                                                size={'xlarge'}
                                                showStatus={true}
                                                online={this.props.online || this.props.id === getCurrentUserId()}
                                            />
                                        </div>

                                        <div className="card-body-main">
                                            <h5><span>{this.props.name}</span></h5>

                                            {
                                                this.props.removed ? (
                                                    <h6>no longer in team</h6>
                                                ) : (
                                                    <h6>{this.getUserRoleById(this.props.role).title + (this.props.pending ? ' (pending)' : '')}</h6>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="card-foot">
                                        <div className="card-meta">
                                            <i className="icon material-icons">email</i>

                                            {this.props.email}
                                        </div>

                                        {
                                            this.props.tz ? (
                                                <div className="card-meta">
                                                    <i className="icon material-icons">access_time</i>

                                                    <span>{moment().utcOffset((this.props.tz || 0) * -1).format('h:mma')} (local time)</span>
                                                </div>
                                            ) : null
                                        }

                                        {
                                            this.props.id && !this.props.removed ? (
                                                <div className="card-cta">
                                                    <button className="btn btn-block btn-xsmall btn-secondary" onClick={this.handleUserProfileClick}>
                                                        <i className="icon material-icons">person</i>

                                                        See profile
                                                    </button>

                                                    <CanUser type="viewChat">
                                                        {
                                                            this.props.id !== getCurrentUserId() && !this.props.pending && canUser('viewChat', [], {role: this.props.role, id: this.props.id}) ? (
                                                                <button className="btn btn-block btn-xsmall btn-secondary" onClick={this.handleStartConversationClick}>
                                                                    <i className="icon ion ion-chatboxes" />

                                                                    Send message
                                                                </button>
                                                            ) : null
                                                        }
                                                    </CanUser>
                                                </div>
                                            ) : null
                                        }
                                    </div>
                                </div>
                            </Popout>
                        </React.Fragment>
                    )

                }
            </div>
        );
    }
}
